'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _components = require('../../components');
var _vacancies = require('./vacancies.json');var _vacancies2 = _interopRequireDefault(_vacancies);
var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

JobsPage = function (_Component) {_inherits(JobsPage, _Component);function JobsPage() {_classCallCheck(this, JobsPage);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}JobsPage.prototype.
  render = function render() {var _props =
    this.props,translate = _props.translate,route = _props.route,locale = _props.locale;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);
    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: translate('title', 'titleTemplate')(),
          title: translate('footer', 'careers')(),
          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route },
          { property: 'og:title', content: translate('footer', 'careers')() + ' | \u202BOnMap' },
          { property: 'og:description', content: translate('helmet', 'jobsDescription') },
          { name: 'description', content: translate('helmet', 'jobsDescription') }],

          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),


        _react2.default.createElement(_components.Jobs, {
          vacancies: _vacancies2.default,
          translate: this.props.translate })));



  };return JobsPage;}(_react.Component);


JobsPage.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  route: _propTypes2.default.any };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
JobsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/JobsPage/JobsPage.js
// module id = 3024
// module chunks = 0